import { ClarityProxy } from 'util/clarity';

export const traceIdInterceptor = response => {
  if (response?.headers?.['trace-id']) {
    ClarityProxy.setTag('trace-id', response.headers['trace-id']);
  }

  return response;
};
